import React from 'react'
import { useQuery } from 'jsonapi-react'
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router'
import isEmpty from 'lodash/isEmpty'

import BaseComposition from 'components/Compositions/Composition/base'
import { Body } from 'layouts/basic'


export default function Composition(props) {
  const { compositionId } = useParams()
  const history = useHistory()
  const location = useLocation()

  console.log(compositionId)

  const { data={}, isFetching, error, refetch } = useQuery(compositionId && [
    'compositions',
    compositionId,
    {
      include: 'created_by,created_by.profile_pic,exported_file,downloads.file',
      'fields[Composition]': 'title,description,permissions,privacy,created_by,created_at,exported_file,status,downloads',
      'fields[User]': 'full_name,profile_pic',
      'fields[File]': 'title,type,file,thumbnail,medium',
    },
  ])

  React.useEffect(() => {
    if (!compositionId) {
      history.push('/')
      return null
    }
    if (error) {
      history.push('/login?redirect=' + location.pathname)
      return null
    }
  }, [compositionId, error]) // eslint-disable-line

  return (
    <Body loading={isFetching && isEmpty(data)}>
      <div className='max-w-3xl ml-auto mr-auto'>
        {
          data.id &&
          <BaseComposition
            {...data}
            onDelete={() => history.push('/')}
            onReload={() => refetch()}
            onUpdate={() => refetch()}
          />
        }
      </div>
    </Body>
  )
}
